import React, { Component } from "react";
import "./RecommendedItineraries.css";
import { RecommendedItinerariesItem } from "./RecommendedItinerariesItem";
import SimpleSlider from "../SimpleSlider/SimpleSlider";
import { getImgUrl } from "../../Utility/Utility";

class RecommendedItineraries2 extends Component {
  constructor(props) {
    super(props);
    this.image_url = getImgUrl();

    this.RecommendedItineraries2SliderSettings = {
      dots: false,
      infinite: true,
      cssEase: "linear",
      autoplay: false,
      lazyLoad: "ondemand",
      slidesToShow: this.props.items != undefined ? this.props.items : 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    this.RecommendedItineraries2 = [
      {
        id: "1",
        title: "Catholic Interest",
        daysTitle: "10 days tour",
        img: "RecommendedItineraries/10/christianInterest.jpg",
        link: "/Posts/itineraries/Catholic_Interest_Itineraries_10_Days_Tour",
      },
      {
        id: "2",
        title: "Evangelical Christians",
        daysTitle: "10 days tour",
        img: "RecommendedItineraries/10/evangelicalChristians.jpg",
        link:
          "/Posts/itineraries/Evangelical_Christian_Itineraries_10_Day_Tour",
      },
      {
        id: "3",
        title: "A Christian Adventure",
        daysTitle: "10 days tour",
        img: "RecommendedItineraries/10/ACHRISTIANADVENTUREITINERARY.jpg",
        link: "/Posts/itineraries/Eilat_To_Jerusalem_In_10_Days",
      },
      {
        id: "4",
        title: "A Christian Interest",
        daysTitle: "10 days tour",
        img:
          "RecommendedItineraries/10/CHRISTIANINTERESTITINERARY10DAYSTOUR.jpg",
        link: "/Posts/itineraries/Christian_Interest_Itinerary_10_Days_Tour",
      },
      {
        id: "5",
        title: "Women in the Old and New Testament",
        daysTitle: "10 days tour",
        img: "RecommendedItineraries/10/womenintheoldandnewtestament.jpg",
        link: "/Posts/itineraries/Women_In_The_Old_And_New_Testament",
      },
    ];
  }

  render() {
    const RecommendedItineraries2Html = this.RecommendedItineraries2.map(
      (o) => {
        return (
          <RecommendedItinerariesItem
            title={o.title}
            daysTitle={o.daysTitle}
            img={o.img}
            link={o.link}
            key={o.id}
            id={o.id}
          />
        );
      }
    );
    return (
      <div className="recommended-itineraries-wrapper">
        <SimpleSlider settings={this.RecommendedItineraries2SliderSettings}>
          {RecommendedItineraries2Html}
        </SimpleSlider>
      </div>
    );
  }
}

export default RecommendedItineraries2;



// WEBPACK FOOTER //
// ./src/Components/RecommendedItineraries/RecommendedItineraries2.js